<template>
  <div
    class="number-search-button"
    :class="{
      'number-search-button disabled': disabled,
      'number-search-button error': error,
      'number-search-button grey': grey
    }"
    @click="onClickBtn"
  >
    <img
      alt="back"
      :src="imgUrl"
      :class="icon === 'search' ? 'number-search-button-image search' : 'number-search-button-image'"
    />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'NumberSearchButton',
  props: {
    disabled: Boolean,
    grey: Boolean,
    error: String,
    onClick: Function,
    icon: String
  },
  computed: {
    imgUrl() {
      const images = require.context('@/assets/images', false);

      let name;
      console.log('this.icon: ' + this.icon);
      switch (this.icon) {
        case 'loading':
          name = 'loading.gif';
          break;
        case 'search':
          name = 'search.png';
          break;
        default:
          name = 'right_arrow_thick.png';
      }
      console.log(images('./' + name));
      return images('./' + name);
    }
  },
  methods: {
    onClickBtn() {
      if (!this.disabled) {
        this.onClick();
      }
    }
  }
});
</script>

<style scoped lang="scss">
.number-search-button {
  width: 60px;
  height: 60px;
  background-color: $colorGreen;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 1;
  margin-left: 20px;

  &.disabled {
    opacity: 0.7;
    cursor: default;
  }

  &.grey {
    background-color: $colorPlaceholder;
  }

  &.error {
    opacity: 0.7;
    background-color: $colorRed;
  }

  .number-search-button-image {
    width: 29px;
    height: 32px;

    &.search {
      width: 24.63px;
      height: 24.63px;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 49px;
    height: 49px;
  }
}
</style>
